"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fragment = exports.default = void 0;
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _client = require("@apollo/client");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _Cell = _interopRequireDefault(require("./designsystem/Cell"));
var _GradientBackground = _interopRequireDefault(require("./designsystem/GradientBackground"));
var _Grid = _interopRequireDefault(require("./designsystem/Grid"));
var _Heading = _interopRequireDefault(require("./designsystem/Heading"));
var _TextClamp = _interopRequireDefault(require("./designsystem/TextClamp"));
var _LocationMap = _interopRequireDefault(require("./LocationMap"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const fragment = exports.fragment = (0, _client.gql)`
    fragment Location on Accommodation {
        descriptionLocation
        pointsOfInterest {
            name
            distance
        }
        coordinates {
            lat
            lon
        }
    }
`;
const Location = props => {
  const {
    data
  } = props;
  const {
    pointsOfInterest,
    coordinates: {
      lat,
      lon
    },
    descriptionLocation
  } = data;
  return __jsx(_react.default.Fragment, null, __jsx(_GradientBackground.default, null), __jsx(UnitContentWrapper, null, __jsx(StyledGrid, null, __jsx(_Cell.default, {
    gridColumn: ['1 / -1', null, null, '1 / 5', null, '1 / 6']
  }, __jsx(_Heading.default, null, __jsx(_Title.default, {
    variant: "large",
    elementType: "h2"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "0xAinF",
    defaultMessage: [{
      "type": 0,
      "value": "Ligging"
    }]
  }))), __jsx(LocationDescription, {
    maxLength: 200,
    text: descriptionLocation
  }), __jsx(NearbyDesktop, null, __jsx(_Heading.default, null, __jsx(_Title.default, null, __jsx(_reactIntl.FormattedMessage, {
    id: "ddY7ME",
    defaultMessage: [{
      "type": 0,
      "value": "In de buurt"
    }]
  }))), __jsx(PointsOfInterest, {
    data: pointsOfInterest
  }))), __jsx(_Cell.default, {
    gridColumn: ['1 / -1', null, null, '5 / -1', null, '6 / -1']
  }, __jsx(_LocationMap.default, {
    position: {
      longitude: lon,
      latitude: lat
    },
    markerPosition: {
      longitude: lon,
      latitude: lat
    }
  })), __jsx(NearbyMobile, null, __jsx(PointsOfInterest, {
    data: pointsOfInterest
  })))));
};
const PointsOfInterest = props => {
  const {
    data
  } = props;
  const sortedPoints = (0, _react.useMemo)(() => [...data]
  // Sort distance from closest to farthest
  .sort((a, b) => a.distance - b.distance), [data]);
  return __jsx(Points, null, sortedPoints.map(({
    name,
    distance
  }) => __jsx(Point, {
    key: name
  }, __jsx(_Body.default, null, name), __jsx(Distance, null, distance < 1000 ? __jsx(_react.default.Fragment, null, __jsx(_reactIntl.FormattedNumber, {
    value: distance
  }), " ", __jsx(_reactIntl.FormattedMessage, {
    id: "blegMn",
    defaultMessage: [{
      "type": 0,
      "value": "meter"
    }]
  })) : __jsx(_react.default.Fragment, null, __jsx(_reactIntl.FormattedNumber, {
    value: Math.round(distance / 100) / 10
  }), ' ', __jsx(_reactIntl.FormattedMessage, {
    id: "aSDgRh",
    defaultMessage: [{
      "type": 0,
      "value": "kilometer"
    }]
  }))))));
};
const UnitContentWrapper = (0, _styledComponents.default)(_ContentWrapper.default).withConfig({
  displayName: "Location__UnitContentWrapper",
  componentId: "sc-1kjaqhb-0"
})(["@media screen and (min-width:", "){margin-top:var(--sectionPadding);}"], ({
  theme
}) => theme.mediaQueries.m);
const NearbyMobile = (0, _styledComponents.default)(_Cell.default).attrs({
  gridColumn: '1 / -1'
}).withConfig({
  displayName: "Location__NearbyMobile",
  componentId: "sc-1kjaqhb-1"
})(["display:none;@media screen and (max-width:", "px){display:block;}"], ({
  theme
}) => theme.mediaQueriesValues.m - 1);
const StyledGrid = (0, _styledComponents.default)(_Grid.default).withConfig({
  displayName: "Location__StyledGrid",
  componentId: "sc-1kjaqhb-2"
})(["> ", " + ", "{margin-top:", ";@media screen and (min-width:", "){margin-top:0;}}"], _Cell.default, _Cell.default, ({
  theme
}) => theme.spacing['50_Semi'], ({
  theme
}) => theme.mediaQueries.m);
const Distance = (0, _styledComponents.default)(_Body.default).attrs(() => ({
  variant: 'tiny'
})).withConfig({
  displayName: "Location__Distance",
  componentId: "sc-1kjaqhb-3"
})(["margin-top:-4px;color:", ";font-weight:300;padding-bottom:", ";"], ({
  theme
}) => theme.colors.neutral['60'], ({
  theme
}) => theme.spacing['30_Small']);
const NearbyDesktop = _styledComponents.default.div.withConfig({
  displayName: "Location__NearbyDesktop",
  componentId: "sc-1kjaqhb-4"
})(["display:none;@media screen and (min-width:", "){margin-top:4rem;display:block;}"], ({
  theme
}) => theme.mediaQueries.m);
const Point = _styledComponents.default.div.withConfig({
  displayName: "Location__Point",
  componentId: "sc-1kjaqhb-5"
})(["break-inside:avoid;page-break-inside:avoid;margin-bottom:", ";"], ({
  theme
}) => theme.spacing['20_Tiny']);
const Points = _styledComponents.default.div.withConfig({
  displayName: "Location__Points",
  componentId: "sc-1kjaqhb-6"
})(["@media screen and (min-width:", "){column-count:2;}"], ({
  theme
}) => theme.mediaQueries.m);
const LocationDescription = (0, _styledComponents.default)(_TextClamp.default).attrs({
  variant: 'regular'
}).withConfig({
  displayName: "Location__LocationDescription",
  componentId: "sc-1kjaqhb-7"
})(["@media screen and (min-width:", "){max-width:44.8rem;}"], ({
  theme
}) => theme.mediaQueries.m);
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Location);